
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
  computed: {},
  filters: {},
  watch: {}
})
export default class Usuario extends Vue {
  title: string = "Usuario";
  errors: any = [];
  fields: any = {
    company: { value: "", label: "Empresa" },
    username: { value: "", label: "Usuario" },
    password: { value: "", label: "Clave", error: false },
    passwordConfirmation: { value: "", label: "Repetir clave", error: false },
    fullname: { value: "", label: "Nombre Completo", error: false },
    email: { value: "", label: "Email", error: false }
  };
  isValid: boolean = true;
  hasToUpdate: boolean = false;
  async mounted() {
    this.loadRequest();
  }
  async loadRequest() {
    let user = this.$store.state.user;
    let companyId = this.$store.state.companyId;
    let company = this.$store.state.user.companies.filter(
      c => c.id === companyId
    )[0];
    for (const key in this.fields) {
      if (
        key !== "company" &&
        key !== "password" &&
        key !== "passwordConfirmation"
      ) {
        this.fields[key] = { ...this.fields[key], value: user[key] };
      } else {
        this.fields.company = { ...this.fields.company, value: company.name };
      }
    }
  }
  passwordValidation() {
    let pass = this.fields.password;
    let pass2 = this.fields.passwordConfirmation;
    if (pass.value.length > 0) {
      if (pass.value !== pass2.value) {
        this.clearErrors();
        this.errors.push("Las claves no coinciden");
        pass.error = true;
        pass2.error = true;
        this.isValid = false;
      } else if (pass.value.length < 5) {
        this.clearErrors();
        this.errors.push(
          "Las claves tiene que tener un mínimo de 5 caracteres"
        );
        pass.error = true;
        pass2.error = true;
        this.isValid = false;
      }
    }
  }
  clearErrors() {
    Object.keys(this.fields).forEach(key => {
      if (this.fields[key].error) {
        this.fields[key].error = false;
      }
    });
    this.errors = [];
  }
  updateUser() {
    this.passwordValidation();
    if (!this.isValid) {
      console.log(this.errors);
      (this.$root as any).notify(this.errors[0], "error");
      setTimeout(() => {
        this.clearErrors();
        this.isValid = true;
      }, 2000);
    } else {
      let user = this.$store.state.user;
      let email = this.fields.email.value;
      let fullname = this.fields.fullname.value;
      let password = this.fields.password.value;
      if (
        email !== user.email ||
        fullname !== user.fullname ||
        password.length > 0
      ) {
        this.hasToUpdate = true;
      }
      if (this.hasToUpdate) {
        this.hasToUpdate = false;
        let updatedData: any =
          password.length > 0
            ? { email, fullname, password }
            : { email, fullname };
        (this.$root as any)._put(`subscriptors/${user.id}`, { ...updatedData });
        this.$store.commit("setUser", {
          ...this.$store.state.user,
          ...updatedData
        });
        this.fields.password.value = "";
        this.fields.passwordConfirmation = "";
        (this.$root as any).notify("Usuario actualizado con éxito!");
      }
    }
  }
}
